import { mediaUrl } from "../lib/api";

export default function Portrait({ photoId, alt, className = "", ratio = "4/5", children }) {
  const url = mediaUrl(photoId);
  return (
    <div className={`relative overflow-hidden rounded-lg border border-line bg-surface-muted ${className}`} style={{ aspectRatio: ratio }}>
      {url ? (
        <img src={url} alt={alt || "Foto"} className="w-full h-full object-cover" loading="lazy" />
      ) : (
        <div data-testid="portrait-placeholder" className="absolute inset-0 flex flex-col items-center justify-center gap-4">
          <span className="font-serif text-6xl text-sub/70 tracking-tight">H.S.</span>
          <span className="w-2.5 h-2.5 rounded-full bg-enji" aria-hidden="true" />
        </div>
      )}
      {children}
    </div>
  );
}

